import { Indicator, Stack, Text } from "@mantine/core";
import { ComponentProps } from "react";

import { useSession } from "@/hooks/@custom/useSession";
import { useGetAttendancesTodayByCompanyQuery, useGetSettingsByCompanyQuery } from "@/store/apis/nextcargo";
import { cn } from "@/utils/cn";

type UserOverviewProps = {
  overview?: {
    company?: {
      name?: string;
    };
  };
} & ComponentProps<typeof Stack>;
export function UserOverview({ overview = {}, className, ...props }: UserOverviewProps) {
  const { driver } = useSession();
  const driverCompanyId = driver?.company.id;
  const driverCompanyName = driver?.company.name || "EMPRESA";
  const [driverFistName] = driver?.name?.split(" ") || [];

  const { data: settingsCompany } = useGetSettingsByCompanyQuery({ id: Number(driverCompanyId)! }, { skip: !driverCompanyId });
  const { data: attendance } = useGetAttendancesTodayByCompanyQuery(
    { id: driverCompanyId! },
    {
      skip: !driverCompanyId,
      selectFromResult: (state) => {
        const start = settingsCompany?.start;
        const end = settingsCompany?.end;

        let weekDays = settingsCompany?.weekDays ? JSON.parse(settingsCompany?.weekDays) : [];
        weekDays = Object.values(weekDays);
        const week = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
        const selectedDays = week.filter((_, index: number) => weekDays[index] === true);

        const data = {
          attendance: state.data?.isInAttendance,
          attendanceStart: start,
          attendanceEnd: end,
          days: selectedDays
        };

        localStorage.setItem("@AppDriver:attendance", JSON.stringify(data));

        return {
          ...state,
          data
        };
      }
    }
  );

  const hasOverview = Object.keys(driver || overview).length > 0;
  const hasAttendance = Object.keys(attendance).length > 0;

  const EMPTY = "-";
  const startDay = attendance.days?.[0] || EMPTY;
  const endDay = attendance.days?.[attendance.days.length - 1] || EMPTY;
  const startAt = attendance.attendanceStart || EMPTY;
  const endAt = attendance.attendanceEnd || EMPTY;

  const active = attendance.attendance ?? false;
  const activeText = active ? "Atendimento Aberto" : "Atendimento Fechado";
  const colorActive = active ? "green" : "red";

  if (!hasOverview && !hasAttendance) return null;

  return (
    <Stack gap="md" className={cn([className])} {...props}>
      {hasAttendance && (
        <div>
          <div className="mb-1 inline-block">
            <Indicator color={colorActive} offset={-15} position="middle-start" processing>
              <Text c={colorActive}>{activeText}</Text>
            </Indicator>
          </div>

          <Text size="sm" style={{ color: "#232323" }}>
            {startDay} - {endDay} de {startAt} às {endAt}
          </Text>
        </div>
      )}

      {hasOverview && (
        <Stack gap="sm" className="mb-8">
          <Text size="3xl" fw="bold" lts="tracking-wide" style={{ color: "#232323" }}>
            Olá {driverFistName},
          </Text>

          <Text size="xl" style={{ color: "#666" }}>
            Bem-vindo(a) ao controle de fila
            <br />
            da {driverCompanyName}.
          </Text>
        </Stack>
      )}
    </Stack>
  );
}
